/** VUEX Cad manager
 *
 * @requires CrulesAPI.js
 */

import { bus }          from '@store/dau';
import { CrulesAPI, HandlerAPI, NextApiClient }    from '@3cad/nextcore';
import { Project }      from '@3cad/nextcore';
import { App } from '@3cad/nextcore';
import NextModals from '@dialogs/index';
import Shape from "@doodle3d/clipper-js";
import { ResolveForcedVars } from '@3cad/nextcore';
import { PopVariant } from '@3cad/nextcore';
import { RowEval } from '@3cad/nextcore';
import { WallCat } from '@3cad/nextcore';
import { V_ModalPopVar, V_ModalDClass } from '@vuectrls/controllers.js';
import { InsertItemPlacer } from '@3cad/nextcore';

export const cadManager = {
    namespaced: true,
    state: {
        iCad: App.getICad(),
        inputWrapper: {},
        multiSelection: false,
        newOrigin: false,
        boxSnap: false,
        collisions: false,
        magicLinks: false,
        wallSnap: false,
        zoomWindow: false,
        selectedBoxes: [],
        layers: [],
        onUpdateCad: (e) => { console.log('%c'+ e, 'color: blue;'); },
        backFaceCulling: null,
        boxCulling: null,
        isActiveTextQuote: false,
        isActiveLinearQuote: false,
        isActiveAngleQuote: false,
        isActiveHighLightQuote: false
    },

    // Get project object's properties
    getters: {
        galleryData(state) {
            console.log('Get gallery ->', App.iCad.getGallery());
            return App.iCad.getGallery();
        },
        multiSelectionState(state) {
            return state.multiSelection;
        },
        newOriginState(state) {
            return state.newOrigin;
        },
        magicLinkState(state) {
            return state.magicLinks;
        },
        boxSnapState(state) {
            return state.boxSnap;
        },
        collisionsState(state) {
            return state.collisions;
        },
        wallSnapState(state) {
            return state.wallSnap;
        },

        zoomWindow(state) {
            return state.zoomWindow;
        },

        data2DBox: (state, getters) => (uid) => {
            return App.iCad.getData2DBox(uid) ||  {};
        },
        /** 2D cad functioins */
        selectedBoxes(state) {
            return state.selectedBoxes;
        },

        layers(state) {
            return state.layers;
        },
        getGhostEngine(state) {
            return state.iCad.getGhostEngine();
        },
        getActiveTypedRow(state) {
            /**
             * return row and type where type can be:
             *  WALL = 1,
                WALLITEM= 2,
                FLOOR = 3,
                BOX = 5,
                CEILINGS = 8
             */
            return state.iCad.getActiveTypedRow();
        },
        backFaceCullingState(state){
            return state.backFaceCulling;
        },
        boxCullingState(state){
            return state.boxCulling;
        },
         isActiveTextQuoteState(state) {
             return state.isActiveTextQuote;
         },
         isActiveLinearQuoteState(state) {
            return state.isActiveLinearQuote;
        },
        isActiveAngleQuoteState(state) {
            return state.isActiveAngleQuote;
        },
        isActiveHighLightQuoteState(state) {
            return state.isActiveHighLightQuote;
        }
    },
    // Mutate project object
    mutations: {
        init(state) {
            state.iCad = App.getICad();
            let onUpdate =  (event, data, callbacktype) => {
                if (callbacktype == CallbackEnumType.ENGINE_2D) {
                    state.onUpdateCad(data, event);
                } else if (callbacktype == CallbackEnumType.ENGINE_3D) {
                    switch(event) {
                        case Eng3d_Callbacks.CB_EVALUATE_WALLS:
                            App.iCad.getCadWrapper().saveWalls();
                            CrulesAPI.cadCallBackEvalWalls(data);
                            break;
                        case Eng3d_Callbacks.CB_EVALUATE_TOPS:
                            this.dispatch("project/cadCallBackEvalTop", {data})
                                .then(res => {
                                    if (data.callbackDone) data.callbackDone(res);
                                })
                                .catch(err => {
                                    if (data.callbackError) data.callbackError(err);
                                });
                            break;
                        case Eng3d_Callbacks.CB_SCRIPT_QUOTE:
                            CrulesAPI.cadCallbackScriptQuote(data);
                            break;
                        case(Eng3d_Callbacks.DONWLOAD_IMG):
                            App.downloadImg(data);
                            break;
                        default:
                            state.onUpdateCad(event, data);
                    }
                } else if (callbacktype == CallbackEnumType.SHARED) {
                    switch (event) {
                        case ("RE_EVAL_OBJ"):
                            App.revalCornerCb(data);
                        break;
                        case ("DELETE_SELECTED_OBJECTS"):
                            state.onUpdateCad(event, data);
                            break;
                        case ("CHANGED_ACTIVE_ROW"):
                            state.onUpdateCad(event, data);
                        break;
                        case ("CHANGED_SELECTION_LIST"):
                            state.selectedBoxes = state.iCad.getSelectedBoxRows();
                            state.onUpdateCad(event, data);
                        break;
                        case ("SELECTED_PLACER_SLOT"):
                            this.dispatch("cad/addRowInPlacer", data);
                        break;
                        case("MOVE_PLACER_SLOT"):
                            this.dispatch("cad/movePlacerSlot", data);
                        break;
                        case ("EXPORT_JSON_SCENE"):
                            this.dispatch("cad/exportObjScene", data);
                        break;
                        case ("PUSH_UNDO_ACTION"):
                            console.log("Push UNDO cadStore");
                            state.onUpdateCad(event, data);
                        break;
                        case ("ZOOM_WINDOW_STATE_CHANGE"):
                            state.zoomWindow = data;
                            state.onUpdateCad(event, data);
                        break;
                        case ("OPEN_QUOTES_POP"):
                            state.onUpdateCad(event, data);
                        break;
                        case ("CHANGED_QUOTES_STATUS"):
                            this.dispatch("cad/updateQuotesStatusAction",data);
                        break;
                        case ("NO_PLACER_SELECTED"):
                            bus.$emit("NO_PLACER_SELECTED", null);
                            break;
                        case ("DOWNLOAD_IMG"):
                            App.downloadImg(data);
                            break;
                        case ("ASK_MAP2D_MEASUREPOP"):
                            state.onUpdateCad(event, data);
                            break;
                        default:
                            state.onUpdateCad(event, data);
                        break;
                    }
                } else {
                    console.error("Missing callback type");
                }
                // Call generic function

            };
            let config = this.getters['getPreferences'];
            let extraData = {};
            extraData.callback = onUpdate;
            extraData.clipperLib = {};
            extraData.clipperLib.libInstance = Shape;
            extraData.clipperLib.libCallback = (paths = [], closed = true, capitalConversion = false, integerConversion = false, removeDuplicates = false) => {
                return new Shape(paths, closed, capitalConversion, integerConversion, removeDuplicates);
            };
            App.initICad(config, extraData);

            state.inputWrapper = App.iCad.getCadWrapper();
            state.multiSelection = App.iCad.getMultiSelectionState();
            state.boxSnap = App.iCad.isSnapEnabled();
            state.collisions = App.iCad.isCollisionEnabled();
            state.magicLinks = App.iCad.isMagicEnabled();
            state.wallSnap = App.iCad.canBoxSnapOnWall();
            state.layers = App.iCad.getLayersExtData();
            // state.backFaceCulling = App.iCad.getBackFaceCulling();
            // state.boxCulling = App.iCad.getBoxCulling();


            bus.$on("SET_PROJECT", e => {
                App.iCad.setProject(this.state.project);
                bus.$emit("REDRAW_3D", null);
            });

        },
        /**
         * @param state
         * @param payload
         */
        initialize(state, payload) {
            let canvas = null;
            let registerEvents = null;
            if(payload) {
                canvas = payload.canvas || null;
                registerEvents = payload.register || null;
            }

            state.inputWrapper.initialize(canvas, registerEvents);
        },
        insertBox(state, project) {
            if(!(project instanceof Project))
                throw 'Param must be an instance of Project';
            App.iCad.insertBox(project);
        },
        insertBoxPlacer(state, project) {
            if(!(project instanceof Project))
                throw 'Param must be an instance of Project';
            App.iCad.insertBoxPlacer(project);
        },
        moveBoxPlacer(state, data) {
            if(!(data.project instanceof Project))
                throw 'Param must be an instance of Project';
            App.iCad.moveBoxPlacer(data.project, data.row);
        },
        wallsToProject(state, project) {
            const wallWrapper = state.inputWrapper;
            if(!(project instanceof Project))
                throw 'Param must be an instance of Project';
            let prj = this.state.project;
            prj.envWall = App.iCad.getEnvWallJson();
            let dataWall = App.iCad.fromWallCadToRows();
            prj.envWall.wallsVector = dataWall.wall;
            prj.envWall.windowInstance = dataWall.windowInstance;
            wallWrapper.detach();
        },
        setProject(state, project) {
            if(!(project instanceof Project))
                throw 'Param must be an instance of Project';
            App.iCad.setProject(project);
        },
        toggleMultislection(state) {
            App.iCad.setMultiSelection(!state.multiSelection);
            state.multiSelection = App.iCad.getMultiSelectionState();
        },
        toggleNewOrigin(state) {
            App.iCad.setSelectNewOrigin(!state.newOrigin);
            state.newOrigin = App.iCad.getNewOriginState();
        },
        toggleBoxSnap(state) {
            App.iCad.setSnapEnabled(!state.boxSnap);
            state.boxSnap = App.iCad.isSnapEnabled();
        },
        toggleMagicLinks(state) {
            App.iCad.setMagicEnabled(!state.magicLinks);
            state.magicLinks = App.iCad.isMagicEnabled();
        },
        toggleCollisions(state) {
            App.iCad.setCollisionEnabled(!state.collisions);
            state.collisions = App.iCad.isCollisionEnabled();
        },
        toggleWallSnap(state) {
            App.iCad.changeActiveBoxSnapWall(!state.wallSnap);
            state.wallSnap = App.iCad.canBoxSnapOnWall();
        },

        toogleZoomWindow(state) {
            App.iCad.zoomWindow(!state.zoomWindow);
            state.zoomWindow = App.iCad.isZoomWindowEnabled();
        },

        updateBoxSnapOnWall(state) {
            state.wallSnap = App.iCad.canBoxSnapOnWall();
        },
        createGroup(state) {
            App.iCad.createGroup();
        },
        removeGroup(state) {
            App.iCad.removeGroup();
        },
        hideLayer(state, layerType) {
            App.iCad.hideLayer(layerType);
            state.layers = App.iCad.getLayersExtData();
        },
        showLayer(state, layerType) {
            App.iCad.showLayer(layerType);
            state.layers = App.iCad.getLayersExtData();
        },
        lockLayer(state, layerType) {
            App.iCad.setLayerInactive(layerType);
            state.layers = App.iCad.getLayersExtData();
        },
        unlockLayer(state, layerType) {
            App.iCad.setLayerActive(layerType);
            state.layers = App.iCad.getLayersExtData();
        },
        enableBoundingQuote(state, enable){
            App.iCad.enableBoundingQuote(enable);
        },
        setCircleQuoteStyle(state, json){
            App.iCad.setCircleQuoteStyle(json);
        },
        setJsonQuoteDynamicinearStyle(state, json){
            App.iCad.setJsonQuoteDynamicinearStyle(json);
        },
        setJsonQuoteBoundingBox(state, json){
            App.iCad.setJsonQuoteBoundingBox(json);
        },
        enableCircleQuotes(state, enable) {
            App.iCad.enableCircleQuotes(enable);
        },
        initializeCanvasYTool(state, data) {
            App.iCad.initializeCanvasYTool(data, data.callBack);
        },
        setWallCreationData(state, data) {
            App.iCad.setWallCreationData(data.length, data.depth);
        },
        applicaRivaluta(state) {
            App.iCad.afterUpdateRules();
        },
        deleteSelectedItem(state) {
            App.iCad.deleteSelectedItem();
        },
        deleteItemByUniqueID(state, uniqueid) {
            App.iCad.deleteItemByUniqueID(uniqueid);
        },
        selectAllBoxes(state) {
            App.iCad.selectAllBoxes();
        },
        deselectAll(state) {
            App.iCad.deselectAll();
        },
        rotateSelectedBoxesIncrement(state, value) {
            App.iCad.rotateSelectedBoxesIncrement(value);
        },
        /**
         * @param state
         * @param handleEventsFunc function to handle events from cad environment
         */
        registerCalback(state, handleEventsFunc) {

            // Check is function
            if(handleEventsFunc && {}.toString.call(handleEventsFunc) === '[object Function]')
                state.onUpdateCad = handleEventsFunc;
            else
                throw 'parameter "handleEventsFunc" is not a function';
        },
        setBackFaceCulling(state, status) {
            // App.iCad.setBackFaceCulling(status);
            state.backFaceCulling = status;
        },
        setBoxCulling(state, status) {
            // App.iCad.setBoxCulling(status);
            state.boxCulling = status;
        },
        updateQuotesStatus(state, status) {
            state.isActiveTextQuote = status.isActiveTextQuote;
            state.isActiveLinearQuote = status.isActiveLinearQuote;
            state.isActiveAngleQuote = status.isActiveAngleQuote;
            state.isActiveHighLightQuote = status.isActiveHighLightQuote;
        }
    },

    // Async operations in project object
    actions: {
        createWalls(context, {prj, points, hWalls = 2700, floorPoints = null}) {
            context.commit('initialize');
            return new Promise((resolve, reject) => {
                App.iCad.setProject(prj);
                let config = this.getters['getConfig'];
                WallCat.getJson(config.pareti).
                then( (wallsJson) => {
                        let data = wallsJson.find(r => r.type === 999);
                        if(!floorPoints)
                            App.iCad.createWalls(points, hWalls, 2, data.list[0].rule);
                        else
                            App.iCad.createWallsWFloor(points, floorPoints, hWalls, 2, data.list[0].rule);
                        resolve();
                    }
                );

            });
        },
        updateQuotesStatusAction(context, data) {
            context.commit("updateQuotesStatus", data);
        },
        rowPhotoshot(context, { prjRow, width = 100, height = 100, fov = 45, angX = 0, angY = 0, newWindow = false, bw = false }) {
            return new Promise((resolve, reject) => {
                App.iCad.scattaFotoRow(prjRow, width, height, fov, angX, angY, newWindow, bw, resolve );
            });
        },
        selectPlacerSlot(context, res) {
            App.iCad.selectPlacerSlot(res);
        },
        addRowInPlacer(context, data) {
            let modalVariant = new V_ModalPopVar(NextModals.popVariant);
            let modalDclass = new V_ModalDClass(NextModals.popDclass, {
                size: 'xl',
                dialogClass: 'modal-full'
            }, App.getConfig().dclass);
            let popVariant = new PopVariant(modalVariant, modalDclass, Object.keys(App.getConfig().dclass));
            InsertItemPlacer.addRowInPlacer(data, this.state.project, this.state.cad.iCad, new ResolveForcedVars(popVariant))
            .then( res => {
                bus.$emit("REDRAW_3D", null);
                bus.$emit("PLACER:ADD", res);
            }
            );
        },
        movePlacerSlot(context, data) {
            let modalVariant = new V_ModalPopVar(NextModals.popVariant);
            let modalDclass = new V_ModalDClass(NextModals.popDclass, {
                size: 'xl',
                dialogClass: 'modal-full'
            }, App.getConfig().dclass);
            let popVariant = new PopVariant(modalVariant, modalDclass, Object.keys(App.getConfig().dclass));
            InsertItemPlacer.moveRowPlacer(data, this.state.project, this.state.cad.iCad, new ResolveForcedVars(popVariant))
            .then( res => {
                bus.$emit("REDRAW_3D", null);
                bus.$emit("PLACER:MOVE", res);
            }
            );
        },
        /*exportJsonScene(context, data) {
            let eval3DScene = data.eval3DScene;
            return new Promise((resolve, reject) => {
                HandlerAPI.exportJsonScene(data,resolve, reject);
            });
        },*/
        exportObjScene(context, data) {
            // let eval3DScene = data.eval3DScene;
            return new Promise((resolve, reject) => {
                // HandlerAPI.exportObjScene(data,resolve, reject);
                let params = {
                    expKey: "OBJ",
                    jsonScene: JSON.stringify(data),
                    _UID: NextApiClient.getUID()
                };
                NextApiClient.comHandler(
                    "exportobjscenedownload",
                    params,
                    {
                        responseType: "blob"
                    },
                    blob => {
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display:none;";
                        let url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = "dump.zip";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    },
                    reject
                );
            });
        },
        exportIGX(context, { rows: rows, data: data, filename = "IGXfile" }) {
            let eval3DScene = rows.eval3DScene;
            return new Promise((resolve, reject) => {
                NextApiClient.comHandler(
                    "exportobjscenedownload",
                    {
                        expKey: "IGX",
                        jsonScene: JSON.stringify(rows),
                        jsonData: JSON.stringify(data)
                    },
                    {
                        responseType: "blob"
                    },
                    blobPdf => {
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display:none;";
                        let url = window.URL.createObjectURL(blobPdf);
                        a.href = url;
                        a.download = "IGXfile.zip";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    },
                    reject
                );
            });
        },
        async projectPicture(context, {
            prj,
            width = 200,
            height = 200,
            fov = 45,
            angX = 20,
            angY = 20,
            newWindow = false,
            bw = false,
        }) {
            return new Promise((resolve, reject) => {
                App.iCad.scattaFotoProject(prj, width, height, fov, angX, angY, newWindow, bw, (base64) => {
                    if(base64) resolve(base64)
                    else reject(new Error('Missing image'))
                })
            });
        },
        openDivider(context, data) {
            let component = data.dataComponent;
            let callBack = data.callBack;
            let currentRow = data.currentRow;

            // component(data)
            component({
                rule: currentRow.rule,
                catalog: currentRow.catalog
            })
                .then(rule => {
                    currentRow.rule = rule;
                    currentRow.reg = rule.reg;
                    if (callBack) {
                        callBack();
                    }
                })
                .catch((mode, rule) => {
                    currentRow.rule = rule;
                    currentRow.reg = rule.reg;
                    if (callBack) {
                        callBack();
                    }
                });
            /*.$once('close', (mode, rule) => {
                currentRow.rule = rule;
                currentRow.reg = rule.reg;
                if (callBack) {
                    callBack();
                }
            });*/
        },

    }
};



// WEBPACK FOOTER //
// ./src/_eng/store/cadStore.js